export default __webpack_public_path__ + "static/kanbanexport-0eda9c5129078c9f9d2beaa504623ea7.pdf";